import { useActionBarOffset } from "$components/action-bar/action-bar-offset";
import { styled } from "@material-ui/core";
import BrowserIsValidIssue from "./browser-is-valid-issue";
import { NoInternetIssue } from "./no-internet-issue";
import { GlobalAppIssueOption } from "./provider";

const Container = styled("div")(({ theme }) => ({
  // The page header battles in the zindex war with 40, so we must match it to be on top
  zIndex: 40,
  position: "fixed",
  // `bottom` is set inline so the overlay sits above any bottom action bar
  // currently on screen (the bar no longer reserves space for the overlay).
  left: 0,
  padding: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  transform: "scale(30%)",
  transformOrigin: "bottom left",
  transition: "transform 0.5s ease-in-out, bottom 0.3s ease-in-out",
  "&:hover,&:active": {
    transform: "scale(100%)",
  },
}));

const Overlay: FC<{ issues: GlobalAppIssueOption[] }> = ({ issues }) => {
  const actionBarOffset = useActionBarOffset();
  return (
    <Container style={{ bottom: actionBarOffset }}>
      {issues.includes(GlobalAppIssueOption.ChromeVersion) && (
        <BrowserIsValidIssue />
      )}
      {issues.includes(GlobalAppIssueOption.NoInternet) && <NoInternetIssue />}
    </Container>
  );
};

export default Overlay;
